import React from "react";

/**
 * 소크라테스 AI 요청데이터 관리
 */
// initial state
export const initialState = {
    interview_info: {
        interview_category: '',
        interviewing_institution: '',
        favorite_subject: '',
        favorite_topic: '',
        special_request: '',
        user_input: ''
    },
    messages: [
        {
            role: 'user',
            content: '',
            response_id: '',
            response_time: 0,
            query_type: null
        }
    ],
    query_type_list: [null],
    persona: '',
    question_count: 0,
    followup_count: -1,
    main_max_count: 10,
    fu_max_count: 1,
    // user_id: '',
    // group_id: -1
}

// SELECT_FORM, GET_FORM, 'RESET_FORM
export const indexReducer = (state, action) => {
    switch (action.type) {
        // 사용자 입력값으로 폼 새로 생성
        case 'CREATE_FORM': {
            const { interview_info } = action.payload
            return {
                ...state,
                interview_info: interview_info
            }
        }
        // 예씨 폼 선택하여 폼 값 업데이트
        case 'SELECT_FORM': {
            const { special_request, favorite_subject, favorite_topic, user_input, main_max_count, fu_max_count } = action.payload
            return {
                ...state,
                interview_info: {
                    ...state.interview_info,
                    special_request: special_request,
                    favorite_subject: favorite_subject,
                    favorite_topic: favorite_topic,
                    user_input: user_input
                },
                main_max_count: main_max_count,
                fu_max_count: fu_max_count,
            }
        }
        // 면접 폼 생성시 주제 선택
        case 'SELECT_TOPIC': {
            const { favorite_topic } = action.payload
            return {
                ...state,
                interview_info: {
                    ...state.interview_info,
                    favorite_topic: favorite_topic
                }
            }
        }
        // 면접 폼 생성시 카테고리 선택
        case 'SELECT_PERSONA': {
            const { persona } = action.payload
            return {
                ...state,
                persona: persona
            }
        }
        // 페르소나 설정
        case 'SELECT_CATEGORY': {
            const { interview_category } = action.payload
            return {
                ...state,
                interview_info: {
                    ...state.interview_info,
                    interview_category: interview_category
                }
            }
        }
        case 'UPDATE_FILE': {
            const { special_request } = action.payload;
            return {
                ...state,
                interview_info: {
                    ...state.interview_info,
                    special_request: special_request
                }
            }
        }
        // 기존 작성된 면접 폼 호출하여 통신 폼에 면접 정보 업데이트
        case 'GET_FORM': {
            const { interview_info, main_max_count, fu_max_count } = action.payload
            return {
                ...state,
                // messages: messages,
                interview_info: interview_info,
                main_max_count: main_max_count,
                fu_max_count: fu_max_count,
            }
        }
        // 진행중인 면접인 경우 이어서 시작할 수 있게 통신 데이터 업데이트
        case 'GET_HISTORY': {
            const { messages, query_type_list, question_count, followup_count } = action.payload
            return {
                ...state,
                messages: messages,
                query_type_list: query_type_list,
                question_count: question_count,
                followup_count: followup_count,
            }
        }
        // 통신 데이터 초기화
        case 'RESET_FORM': {
            return {
                ...state,
                interview_info: {
                    interview_category: '',
                    interviewing_institution: '',
                    favorite_subject: '',
                    favorite_topic: '',
                    special_request: '',
                    user_input: ''
                },
                messages: [
                    {
                        role: 'user',
                        content: '',
                        response_id: '',
                        response_time: 0,
                        query_type: null
                    }
                ],
                query_type_list: [null],
                question_count: 0,
                followup_count: -1,
                main_max_count: 10,
                fu_max_count: 1,
            }
        }
        // 면접 재시작시 interview_info 제외 모든 데이터 초기화
        case 'RESTART_INTERVIEW': {
            return {
                ...state,
                messages: [
                    {
                        role: 'user',
                        content: '',
                        response_id: '',
                        response_time: 0,
                        query_type: null
                    }
                ],
                query_type_list: [null],
                question_count: 0,
                followup_count: -1,
                main_max_count: 10,
                fu_max_count: 1,
            }
        }
        // 유저 답변 message배열에 추가
        case 'UPDATE_USER': {
            const { messages, query_type_list } = action.payload
            return {
                ...state,
                messages: messages,
                // question_count: question_count,
                // followup_count: followup_count,
                query_type_list: query_type_list
            }
        }
        // 소크라테스 질문 message배열에 추가
        case 'UPDATE_SOCRATES': {
            const { response_id, response, question_count, followup_count, query_type, query_type_list } = action.payload;
            const updatedMessages = [...state.messages];
            const messageIdx = state.messages.length - 1;

            if (messageIdx >= 0) {
                updatedMessages[messageIdx].response_id = response_id;
                updatedMessages.push({
                    role: 'assistant',
                    content: response,
                    response_time: 0,
                    response_id: response_id,
                    query_type: query_type
                })

            } else {
                updatedMessages.push({
                    role: 'assistant',
                    content: response,
                    response_time: 0,
                    response_id: response_id,
                    query_type: query_type
                })
            }
            return {
                ...state,
                messages: updatedMessages,
                question_count: question_count,
                followup_count: followup_count,
                query_type_list: [...query_type_list]
            }
        }
        case 'UPDATE_USERINFO': {
            const {user_id, group_id} = action.payload;
            return {
                ...state,
                user_id: user_id,
                group_id: group_id
            }
        }
        default:
            return state;
    }
}